import { Injectable } from "@angular/core";
import { SpecialMealDTO } from "../shared/Models/WidgetSettingsModels";

@Injectable({
    providedIn: 'root'
})
export class ActivitiesDataDic {

    private _Property: ActivitiesData = {};

    public setProperty(data: any[]){
        data.forEach(property => {
            let _activities: {[key: number]: SpecialMealDTO} = {}; 

            if(property.AvailableSpecialMeals){
                property.AvailableSpecialMeals.forEach(activity => {
                    _activities[activity.Id] = activity;
                });
            }
            
            this._Property[property.RestaurantId] = {
                WidgetPrePaymentMode: property.WidgetPrePaymentMode,
                WidgetPaymentNote: property.WidgetPaymentNote,
                Activity: _activities
            }
        });
    }

    public get Property():ActivitiesData{
        return this._Property;
    }
}


interface ActivitiesData{
    [key: number]: {
        WidgetPrePaymentMode: number,
        WidgetPaymentNote: number,
        Activity: {
            [key: number] : SpecialMealDTO
        }
    }
}